export default __webpack_public_path__ + "static/media/Category-N-Laminate.c378d02d.jpg";